<template>
  <div class="header-wrap">
    <div class="header">
      <img src="../assets/logo.png" alt="logo" class="logo" />
      <ul class="menu-wrap">
        <li
          :class="[
            'item-menu',
            item.value === curRouter ? 'item-menu-active' : '',
          ]"
          v-for="(item, index) in routerList"
          :key="index"
          @mouseenter="mouseEnter(item)"
          @mouseleave="mouseLeave"
        >
          <div
            @click="handleTo(item.value)"
            :class="[
              'item-menu-box',
              isChild && item.value === 'product' ? 'item-menu-box-active' : '',
            ]"
          >
            {{ item.name }}
          </div>
          <div v-if="isChild && item.value === 'product'" class="children-menu">
            <div class="item-children-menu" @click="changeChild('1')">
              信息软件服务
            </div>
            <div class="item-children-menu" @click="changeChild('2')">
              运营管理服务
            </div>
            <div class="item-children-menu" @click="changeChild('3')">
              售后服务
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["scWidth"],
  data() {
    return {
      deviceType: localStorage.getItem("deviceType"),
      routerList: [
        { name: "首页", value: "index" },
        { name: "走进飞碟", value: "company" },
        { name: "信息化系统", value: "product", children: [{}, {}, {}] },
        { name: "成功案例", value: "case" },
        { name: "新闻动态", value: "news" },
        // { name: "招贤纳士", value: "join" },
        { name: "联系我们", value: "contact" },
      ],
      curRouter: "",
      isChild: false, // 是否有二级菜单
    };
  },
  mounted() {
    if (this.$route.path.split("/")[1]) {
      this.curRouter = this.$route.path.split("/")[1];
    }
  },
  methods: {
    changeChild(type) {
      this.$router.push({ path: "/product", query: { type: type } });
    },
    mouseEnter(info) {
      this.isChild = info.value === "product";
    },
    mouseLeave() {
      this.isChild = false;
    },
    handleTo(routeName) {
      if (routeName === "case") {
        if (this.curRouter !== "index") {
          this.curRouter = routeName;
          this.$router.push(routeName);
          setTimeout(() => {
            scrollTo({
              top: document.getElementById("case").getBoundingClientRect().top,
            });
          }, 200);
        } else {
          scrollTo({
            top: document.getElementById("case").getBoundingClientRect().top,
          });
        }
      } else if (routeName === "product") {
        this.$router.push({ path: "/product", query: { type: "1" } });
      } else {
        this.curRouter = routeName;
        this.$router.push(routeName);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header-wrap {
  width: 100%;
  height: 70px;
  background: url("../assets/headerBg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  // pc端
  .header {
    width: 90%;
    min-width: 1200px;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .menu-wrap {
      display: flex;
      gap: 22px;
      color: #fff;
      list-style-type: none;
      margin: 0;
      height: 100%;
      .item-menu {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-bottom: 2px solid rgba(0, 0, 0, 0);
        .item-menu-box {
          height: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 22px;
        }
        .item-menu-box-active {
          background: #fff;
          color: #006ede;
          border-radius: 5px;
        }
        .children-menu {
          position: absolute;
          top: 70px;
          z-index: 9;
          height: 150px;
          width: 154px;
          background: #fff;
          .item-children-menu {
            width: 100%;
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #000;
            border-bottom: 1px solid #000;
          }
          .item-children-menu:hover {
            background: #006ede;
            color: #fff;
          }
        }
      }
      .item-menu-active {
        border-bottom: 2px solid #fff;
      }
      .item-menu:hover {
        border-bottom: 2px solid #fff;
        cursor: pointer;
      }
    }
  }
  // mobile
  .mobile-header {
    width: 100%;
    padding: 0 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .mobile-logo {
      width: 187px;
    }
  }
}
.logo {
  width: 187px;
  height: 46px;
}
</style>
